module.exports = __webpack_public_path__ + "static/media/home.70c4d5a6.svg";